import { ADVOCACY } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export default function Advocacy() {
  return (
    <section
      id="advocacy"
      data-testid="advocacy-section"
      className="border-b border-[var(--line)] bg-[#eae7dd]"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
        {/* Header band */}
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow testid="advocacy-eyebrow">{ADVOCACY.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-7 font-display text-4xl font-light tracking-tight text-[#1c2b4a] md:text-5xl lg:text-6xl">
                {ADVOCACY.heading}
              </h2>
            </Reveal>
          </div>
          <div className="flex items-end lg:col-span-5">
            <Reveal delay={0.15}>
              <p className="max-w-md border-l-2 border-[#9c7a33] pl-6 text-base leading-relaxed text-[#5c6474] md:text-lg">
                {ADVOCACY.intro}
              </p>
            </Reveal>
          </div>
        </div>

        {/* The docket */}
        <Reveal delay={0.15}>
          <div className="mt-16 overflow-hidden rounded-sm border border-[var(--line)] bg-white">
            <div className="flex items-center justify-between bg-[#faf8f5] px-6 py-4 md:px-10">
              <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#9c7a33]">
                The Docket
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#5c6474]">
                05 Active Causes
              </span>
            </div>
            {ADVOCACY.areas.map((a, i) => (
              <div
                key={a.no}
                data-testid={`advocacy-area-${a.no}`}
                className={`group relative grid gap-3 px-6 py-9 transition-colors duration-300 hover:bg-[#faf8f5] md:grid-cols-12 md:gap-8 md:px-10 ${
                  i === 0 ? "" : "border-t border-[var(--line)]"
                }`}
              >
                <span className="absolute inset-y-0 left-0 w-[3px] bg-[#9c7a33] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <span className="font-mono text-xs text-[#9c7a33] md:col-span-2">
                  [ CAUSE-{a.no} ]
                </span>
                <h3 className="font-display text-2xl leading-tight text-[#1c2b4a] transition-colors duration-500 group-hover:text-[#9c7a33] md:col-span-4 md:text-3xl">
                  {a.title}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-[#5c6474] md:col-span-6">
                  {a.body}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
